/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Conversations_Empty_No_Calendar_TitleInputs */



/**
* | output |
* | --- |
* | "No conversations here yet" |
*
* @param {Conversations_Empty_No_Calendar_TitleInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const conversations_empty_no_calendar_title = /** @type {((inputs?: Conversations_Empty_No_Calendar_TitleInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Conversations_Empty_No_Calendar_TitleInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Nog geen gesprekken hier")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Pas encore de conversations ici")
	return /** @type {LocalizedString} */ ("No conversations here yet")
});